import React from 'react';
import Transactions from './Transactions';
import Statement from './Statement';

const RenderContent = ({ activeTabMain, customerData }) => {
	switch (activeTabMain) {
		case 'Transactions':
			return <Transactions customer={customerData} />;
		case 'Statement':
			return <Statement />;
		default:
			return <Transactions customer={customerData} />;
	}
};

export default RenderContent;
